import type { ComponentProps } from "react";

import { cn } from "@/shared/lib/cn";
import { inputClassName } from "@/shared/ui/styles";

export function Input({ className, ...props }: ComponentProps<"input">) {
  return <input className={cn(inputClassName, className)} {...props} />;
}
